/**
 * Strips a leading "CRMV" prefix (and any separating hyphen/colon/spaces) from a
 * raw CRMV string like "CRMV-SP 31902", leaving just "SP 31902". Used wherever
 * the CRMV value is shown next to its own "CRMV:" label (composing the prefixed
 * form there would read as "CRMV: CRMV-SP 31902"); callers that want the full
 * "CRMV-SP 31902" form inline in a sentence should use the raw value instead.
 */
export function stripCrmvPrefix(crmvRaw: string): string {
  return crmvRaw.replace(/^CRMV[\s-]*:?[\s-]*/i, "").trim() || crmvRaw;
}
